import { IS_DEV } from '@webapp/infrastructure/envs'

const STORAGE_KEY = '__procurify_dev_session_ff'

export type FFOverrides = Record<string, boolean>

let cache: FFOverrides | null = null

/**
 * Dev-only feature-flag overrides, persisted in sessionStorage so they survive
 * page refreshes within a tab. Consulted by FeatureFlagService (which reads
 * live LaunchDarkly values and would otherwise ignore Redux-level overrides)
 * and by the ProcurifyDevTools saga that merges them into the Redux store.
 * The in-memory cache avoids a JSON.parse on every getFlag call.
 */
export const readFFOverrides = (): FFOverrides => {
  if (!IS_DEV) return {}

  if (cache === null) {
    try {
      cache =
        JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}') || {}
    } catch (e) {
      cache = {}
    }
  }

  return cache
}

export const writeFFOverride = (key: string, value: boolean) => {
  if (!IS_DEV) return

  try {
    cache = { ...readFFOverrides(), [key]: value }

    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(cache))
  } catch (e) {
    console.error('Error saving Feature Flag override', e)
  }
}

export const clearFFOverrides = () => {
  if (!IS_DEV) return

  try {
    cache = {}

    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    console.error('Error clearing Feature Flag overrides', e)
  }
}
